import { render, staticRenderFns } from "./BrokersTable.vue?vue&type=template&id=11a42b3c"
import script from "./BrokersTable.vue?vue&type=script&lang=js"
export * from "./BrokersTable.vue?vue&type=script&lang=js"
import style0 from "./BrokersTable.vue?vue&type=style&index=0&id=11a42b3c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports